
export class Profile {
    constructor(name) {
        this.name = name;
        this.insta = '';
        this.items = [];
        this.sections = [];
        this.description = '';
        this.descriptionExtended = '';
        this.collectionImg = null;
    }

    createSection(sectionName) {
        // Replace spaces with '\u00A0' to make spaces bigger
        sectionName = sectionName.replace(/ /g, '\u00A0\u00A0');
        this.sections.push(sectionName);
    }

    createItem(name) {
        const item = new Item(name);

        // What id should this item have?
        item.index = this.items.length;
        // Update the item section to be the last one made
        item.section = this.sections.length;
        item.artist = this;

        // Add the item
        this.items.push(item);
    }

    addSizeAndPrice(size, price, priceId) {
        this.currentItem().prices[size] = {
            price: price,
            priceId: priceId
        }
    }

    addTestPriceId(priceId) {
        this.currentItem().testPriceId = priceId;
    }

    addImage(image) {
        this.currentItem().images.push(image);
    }

    addDescription(text) {
        this.currentItem().description = text;
    }

    addDetails(text) {
        this.currentItem().details = text;
    }

    currentItem() {
        return this.items[this.items.length-1];
    }

    setStock(n) {
        this.currentItem().stock = n;
    }

    setMockup(image) {
        this.currentItem().mockup = image;
    }

    setId(id) {
        this.currentItem().id = id;
    }
}


class Item {
    constructor(title) {
        this.title = title;
        this.index = null;
        this.section = null;
        this.prices = {};
        this.mockup = null;
        this.images = [];
        this.description = '';
        this.details = '';
        this.stock = 1;
        this.artist = null;
        this.id = '';
        this.testPriceId = null;
    }

    getPrice(size) {
        return this.prices[size].price;
    }

    getSize() {
        return Object.keys(this.prices)[0];
    }

    getPriceId(size) {
        if (process.env.REACT_APP_TEST_PAYMENT_MODE === "true") return this.testPriceId;

        return this.prices[size].priceId;
    }

    isAvailable() {
        return this.stock !== 0;
    }
}